const REMOTE_API_BASE_URL = "https://api.hotple.com";
const LOCAL_API_HOSTNAMES = new Set(["localhost", "127.0.0.1"]);
const isLocalBrowser =
  typeof window !== "undefined" && LOCAL_API_HOSTNAMES.has(window.location.hostname);
const PUBLIC_API_BASE_URL = isLocalBrowser
  ? "/api/backend/api"
  : `${REMOTE_API_BASE_URL}/api`;
const SERVER_API_BASE_URL =
  process.env.SERVER_HOST_API_KEY ||
  process.env.NEXT_PUBLIC_API_URL ||
  "http://127.0.0.1:8000/api";

export const HOST_API_KEY =
  typeof window === "undefined" ? SERVER_API_BASE_URL : PUBLIC_API_BASE_URL;
export const BASE_URL = REMOTE_API_BASE_URL;
// export const HOST_API_KEY = "http://localhost:5000/api";
// export const BASE_URL = "http://localhost:5000";
export const IP_INFO_API_KEY = "ba2012ae8cd39f";

export const MAIN_HOTPLE_LOGO_URL = `${BASE_URL}/images/main-logo.png`;
export const WATERMARK_HOTPLE_LOGO_URL = `${BASE_URL}/images/watermark-logo.png`;

export const CLOUDFRONT_BASE_URL =
  process.env.NEXT_PUBLIC_IMAGE_CDN_BASE_URL ||
  `https://img.hotple.com`;

export const VIDEO_CDN_BASE_URL =
  process.env.NEXT_PUBLIC_VIDEO_CDN_BASE_URL ||
  `https://video.hotple.com`;
